import Vue from 'vue'
// import App from '@/pages/ceshi.vue'
import App from './App.vue'
// import App from './pages/mine/Member.vue'
// 引入路由
import router from '@/router/index.js'

import axios from 'axios'

import '@/assets/base.css'

// 全局配置
import 'amfe-flexible/index.js'

import {
  POST,
  GET,
  POSTONE,
  GETONE,
  POSTTWO
} from './utils/myaxios'
// 引入vant组件
import { Swipe, SwipeItem, Toast, NavBar, Popup, Button, Cell, CellGroup, Tabbar, TabbarItem, Icon, Tab, Tabs, Search, Field, Picker, Area, Col, Row, Form, Dialog, Sidebar, SidebarItem, Collapse, CollapseItem, Pagination, PullRefresh, List, DatetimePicker, Image as VanImage } from 'vant'
// Vue.prototype.$POSTOne = POSTOne;
// Vue.prototype.$POSTTwo = POSTTwo;
import VueTouch from 'vue-touch'
import { wechatShare } from '@/common/wechatShare'

Vue.prototype.$share = wechatShare
Vue.config.productionTip = false
Vue.prototype.$POST = POST
Vue.prototype.$GET = GET
Vue.prototype.$POSTONE = POSTONE
Vue.prototype.$POSTTWO = POSTTWO
Vue.prototype.$GETONE = GETONE
Vue.use(DatetimePicker)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Pagination)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Swipe)
Vue.use(VanImage)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(SwipeItem)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Popup)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Area)
Vue.use(Col)
Vue.use(Row)
Vue.use(Form)
Vue.use(Dialog)
Vue.config.productionTip = false
Vue.use(VueTouch, { name: 'v-touch' })
require('@/common/common.js')

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
